import { render, staticRenderFns } from "./podium.vue?vue&type=template&id=5977a25e&scoped=true&"
import script from "./podium.vue?vue&type=script&lang=js&"
export * from "./podium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5977a25e",
  null
  
)

export default component.exports